// extracted by mini-css-extract-plugin
module.exports = {"Controllers":"burgercontroller_Controllers__32K_t","OrderButton":"burgercontroller_OrderButton__2EgNQ","anim":"burgercontroller_anim__3VYxE","ani":"burgercontroller_ani__3g7kl"};